import script from "./Condolence.vue?vue&type=script&setup=true&lang=js"
export * from "./Condolence.vue?vue&type=script&setup=true&lang=js"

import "./Condolence.vue?vue&type=style&index=0&id=c93a54e0&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-c93a54e0"]])

export default __exports__